module.exports = __webpack_public_path__ + "static/media/Ruzova.ffc73f1a.md";